import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { collection } from '../../utils/collection';
import { Room } from './Room';
import { concatMap, share } from 'rxjs/operators';
import { filterNonNil } from '../../utils/rxUtil';
import { mapConnectionDescriptorFromDto } from './ConnectionDescriptor';
import assert from 'assert';
import { action } from 'mobx';
import { Store } from 'libx';
var RoomStore = /*#__PURE__*/function (_Store) {
  /**
   *
   * @param {import('../API').MessagingAPI} messagingAPI
   * @param {Function} primeConversation
   * @param {Function} primeMember
   */
  function RoomStore() {
    var _this;
    _classCallCheck(this, RoomStore);
    _this = _callSuper(this, RoomStore, arguments);
    /**
     *
     * @param {Room} props
     * @returns {Room | undefined}
     */
    _this.primeRoom = function (props) {
      if (!props) {
        return undefined;
      }
      if (!props.id) {
        return undefined;
      }
      _this.fetchRoom(props.id);
      return _this.rooms.set(props);
    };
    assert(_this.rootStore.messagingAPI, 'No API passed to RoomStore');
    assert(_this.rootStore.messageStore.primeConversation, 'No primeConversation passed to RoomStore');
    assert(_this.rootStore.memberStore.setAndFetch, 'No primeMember passed to RoomStore');
    _this.api = _this.rootStore.messagingAPI.rooms;
    _this.primeConversation = _this.rootStore.messageStore.primeConversation.bind(_this.rootStore.messageStore);
    _this.primeMember = _this.rootStore.memberStore.setAndFetch.bind(_this.rootStore.memberStore);
    _this.fetchRoom = _this.fetchRoom.bind(_this);
    _this.joinRoom = _this.joinRoom.bind(_this);
    _this.rooms = collection({
      idAttribute: 'id',
      create: function create(attrs) {
        if (!attrs.conversation_id) {
          return Room.none;
        }
        _this.primeConversation({
          id: attrs.conversation_id
        });
        return new Room(_this.primeConversation({
          id: attrs.conversation_id
        }));
      }
    });
    _this.events$ = _this.rootStore.messagingAPI.events$.pipe(
    // Ensures events are processed serially.
    concatMap(_this.handleServerEvent.bind(_this)), filterNonNil(), share());
    _this.events$.subscribe();
    return _this;
  }

  /**
   * Fetches a Room by id
   *
   * @param {string} roomId
   * @returns {Room}
   */
  _inherits(RoomStore, _Store);
  return _createClass(RoomStore, [{
    key: "fetchRoom",
    value: (function () {
      var _fetchRoom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(roomId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.get(roomId).then(action(this.rooms.set)));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchRoom(_x) {
        return _fetchRoom.apply(this, arguments);
      }
      return fetchRoom;
    }())
  }, {
    key: "joinRoom",
    value: (
    /**
     *
     * @param {string} id
     * @returns {import('./ConnectionDescriptor').RoomConnectionDescriptor}
     */
    function () {
      var _joinRoom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.api.join(id).then(mapConnectionDescriptorFromDto));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function joinRoom(_x2) {
        return _joinRoom.apply(this, arguments);
      }
      return joinRoom;
    }()
    /**
     * Handles realtime events from the server and maps
     * them to application events.
     *
     * @param {import('./RoomMessageDTO').RoomMessageEventDTO} event
     * @returns {Promise<import('./RoomEvents').RoomEvent>}
     * @private
     */
    )
  }, {
    key: "handleServerEvent",
    value: (function () {
      var _handleServerEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = event.type;
              _context3.next = _context3.t0 === 'ROOM_CREATED' ? 3 : _context3.t0 === 'ROOM_CLOSED' ? 7 : _context3.t0 === 'ROOM_PARTICIPANT_CONNECTED' ? 11 : _context3.t0 === 'ROOM_PARTICIPANT_DISCONNECTED' ? 16 : _context3.t0 === 'ROOM_SESSION_STARTED' ? 21 : _context3.t0 === 'ROOM_SESSION_ENDED' ? 26 : 31;
              break;
            case 3:
              _context3.next = 5;
              return this.fetchRoom(event.payload.id);
            case 5:
              _context3.t1 = _context3.sent;
              return _context3.abrupt("return", {
                type: 'RoomCreated',
                room: _context3.t1
              });
            case 7:
              _context3.next = 9;
              return this.fetchRoom(event.payload.id);
            case 9:
              _context3.t2 = _context3.sent;
              return _context3.abrupt("return", {
                type: 'RoomClosed',
                room: _context3.t2
              });
            case 11:
              _context3.next = 13;
              return this.fetchRoom(event.payload.id);
            case 13:
              _context3.t3 = _context3.sent;
              _context3.t4 = event.payload.participant_user_public_id;
              return _context3.abrupt("return", {
                type: 'RoomParticipantConnected',
                room: _context3.t3,
                participantUserPublicId: _context3.t4
              });
            case 16:
              _context3.next = 18;
              return this.fetchRoom(event.payload.id);
            case 18:
              _context3.t5 = _context3.sent;
              _context3.t6 = event.payload.participant_user_public_id;
              return _context3.abrupt("return", {
                type: 'RoomParticipantDisconnected',
                room: _context3.t5,
                participantUserPublicId: _context3.t6
              });
            case 21:
              _context3.next = 23;
              return this.fetchRoom(event.payload.id);
            case 23:
              _context3.t7 = _context3.sent;
              _context3.t8 = event.payload.session_id;
              return _context3.abrupt("return", {
                type: 'RoomSessionStarted',
                room: _context3.t7,
                sessionId: _context3.t8
              });
            case 26:
              _context3.next = 28;
              return this.fetchRoom(event.payload.id);
            case 28:
              _context3.t9 = _context3.sent;
              _context3.t10 = event.payload.session_id;
              return _context3.abrupt("return", {
                type: 'RoomSessionEnded',
                room: _context3.t9,
                sessionId: _context3.t10
              });
            case 31:
              return _context3.abrupt("return", {
                type: 'Unknown',
                room: Room.none
              });
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleServerEvent(_x3) {
        return _handleServerEvent.apply(this, arguments);
      }
      return handleServerEvent;
    }())
  }]);
}(Store);
export { RoomStore as default };
//# sourceMappingURL=RoomStore.js.map
